import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import {
  getDirections,
  getEventTypes,
  getGames,
  getPlatforms,
  getChannels,
  getClassTags,
  getTechTags,
  getTypeTags,
} from '../../store/actions/collections';

const extraFieldsRequest = {
  typeTag: {
    request: values => getTypeTags('grid', values),
  },
  techTag: {
    request: values => getTechTags('grid', values),
  },
  classTag: {
    request: values => getClassTags('grid', values),
  },
  channel: {
    request: values => getChannels('grid', values),
  },
};

const useDynamicFiltersLoader = (values, extraFields) => {
  const dispatch = useDispatch();
  const [debouncedMainOptionsRequest] = useDebouncedCallback(values => {
    dispatch(getDirections('grid', values));
    dispatch(getEventTypes('grid', values));
    dispatch(getGames('grid', values));
    dispatch(getPlatforms('grid', values));
  }, 500);

  const [debouncedExtraOptionsRequest] = useDebouncedCallback(
    (values, extraFields) => {
      if (extraFields) {
        extraFields.forEach(field => {
          Object.entries(extraFieldsRequest).forEach(([key, value]) => {
            if (key === field) {
              dispatch(value.request(values));
            }
          });
        });
      }
    },
    500,
  );

  useEffect(() => debouncedMainOptionsRequest(values), [values, dispatch]);
  useEffect(() => debouncedExtraOptionsRequest(values, extraFields), [
    extraFields,
    dispatch,
  ]);
};

export default useDynamicFiltersLoader;
